import Profile from "@/types/profile";
import { atomWithStorage } from "jotai/utils";

const initialValue: Profile | null = null

const profileAtom = atomWithStorage<Profile | null>('profile', initialValue)

export default profileAtom
